import React, { FC } from 'react';
import styles from '../nav.module.scss';

interface IProps {
  openMenu: boolean;
  onClickBurger: () => void;
}

export const BurgerButton: FC<IProps> = ({ openMenu, onClickBurger }) => {
  return (
    <button
      className={`${styles.burger} ${openMenu ? styles.active : ''}`}
      onClick={onClickBurger}
    >
      <span className={styles.topBurgerElement}>
        <svg width="26" height="3" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <rect width="26" height="3" />
        </svg>
      </span>
      <span className={styles.bottomBurgerElement}>
        <svg width="26" height="3" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <rect width="26" height="3" />
        </svg>
      </span>
    </button>
  );
};
